import React from 'react';

const HeroContainer = ({ children, className }) => {
  return <div className={`${className} rounded-b-[40px] bg-[#012E33]`}>{children}</div>;
};

export default HeroContainer;
